import Cookies from 'js-cookie';
import { safeWindow } from '../safeWindow/safeWindow';
import { FeatureFlags, Features, FEATURE_FLAGS_KEY } from './FeatureFlag.type';

const getCookieFeatureFlags = (): Partial<FeatureFlags> | undefined => {
  const encodedFeatureFlags = Cookies.get(FEATURE_FLAGS_KEY);

  return encodedFeatureFlags
    ? (JSON.parse(decodeURIComponent(encodedFeatureFlags)) as FeatureFlags)
    : undefined;
};

/**
 * Base flags come from `window.__featureFlags`, injected into the SSR HTML by the server
 * (app-root `windowEnv.config.ts`). A readable `featureFlags` cookie acts as a manual,
 * per-browser override on top of them (e.g. set via DevTools for testing) — and is also
 * how local dev works (`dev-entry.tsx` seeds it, as `webpack serve` has no SSR).
 * Note: the cookie set by the server itself is `httpOnly`, hence invisible here by design.
 */
const getFeatureFlags = (): Partial<FeatureFlags> | undefined => {
  const injectedFeatureFlags = safeWindow().__featureFlags;
  const cookieFeatureFlags = getCookieFeatureFlags();

  if (!injectedFeatureFlags && !cookieFeatureFlags) {
    return undefined;
  }

  return { ...injectedFeatureFlags, ...cookieFeatureFlags };
};

export const isFeatureEnabled = (featureName: Features): boolean => {
  const featureFlags = getFeatureFlags();

  return !!featureFlags?.[featureName];
};
